<template>
  <div class="main">
    <div class="nav">
      <span>物流列表</span>
    </div>
    <div class="container">
      <div class="search">
        <div>
          <div class="demo-input-suffix">
            订单号:
            <el-input class="searchInput" size="small" v-model="input" placeholder="请输入内容"></el-input>
          </div>
          <div class="demo-input-suffix">
            物流单号:
            <el-input class="searchInput" size="small" v-model="input" placeholder="请输入内容"></el-input>
          </div>
          <el-button size="mini" type="primary">查询</el-button>
        </div>
      </div>
      <el-alert class="total" title="当前页选择:0" type="info" show-icon></el-alert>
      <div class="itemNav">
        <span>
          <el-checkbox v-model="allChecked">全选</el-checkbox>
        </span>
        <span>序号</span>
        <span>订单号</span>
        <span>物流单号</span>
        <span>Shopify同步状态</span>
        <span>店铺名</span>
        <span>更新时间</span>
      </div>
      <div class="item" v-for="(item,index) in 12" :key="index">
        <span>
          <el-checkbox v-model="allChecked"></el-checkbox>
        </span>
        <span>01</span>
        <span>2287418605613</span>
        <span>LA986550165CN</span>
        <span>已同步</span>
        <span>namioq</span>
        <span>2020-05-11 10:11</span>
      </div>
      <div class="pag">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="30"
          prev-text="< Previous"
          next-text="Next >"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: "",
      allChecked: false,
    };
  },
  methods: {
    // 绑定店铺
    enterBindStore() {
      this.$router.push({
        path: "/bindStore"
      });
    }
  },
};
</script>

<style lang="less" scoped>
.main {
  background-color: #fff;
  border: 1px solid rgba(235, 237, 248, 1);
  > .nav {
    height: 50px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 50px;
    border-bottom: 1px solid rgba(235, 237, 248, 1);
    padding-left: 20px;
    display: flex;
    justify-content: space-between;
    > span > span {
      text-align: center;
      padding-right: 20px;
      height: 12px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 119, 255, 1);
      line-height: 12px;
      cursor: pointer;
    }
  }
}
.container {
  width: 100%;
  padding: 0 20px;
  padding-top: 20px;
  border: none;
  box-sizing: border-box;
  .search {
    margin-bottom: 10px;
    > div {
      display: flex;
      > div {
        margin-right: 20px;
      }
    }
    > div:last-child {
      margin-right: 0px;
    }
    .searchInput {
      width: 200px;
      border-radius: 0px;
      /deep/ .el-input__inner {
        border-radius: 0px;
      }
    }
    .searchBtn {
      height: 40px;
      background: rgba(0, 119, 255, 1);
      border-radius: 0px 3px 3px 0px;
    }
  }
  .total {
    margin: 10px 0;
  }
  .itemNav,
  .item {
    padding-left: 18px;
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
    }
    span:nth-child(1) {
      width: 60px;
      display: inline-block;
      margin-right: 0;
    }
    span:nth-child(2) {
      display: inline-block;
      width: 5%;
    }
    span:nth-child(3) {
      display: inline-block;
      width: 20%;
    }
    span:nth-child(4) {
      display: inline-block;
      width: 20%;
    }
    span:nth-child(5) {
      display: inline-block;
      width: 15%;
    }
    span:nth-child(6) {
      display: inline-block;
      width: 14%;
    }
    span:nth-child(7) {
      display: inline-block;
      width: 15%;
    }
    span:nth-child(8) {
      display: inline-block;
      width: 10%;
    }
  }
  .itemNav {
    margin-bottom: 10px;
  }
  .item {
    background: rgba(246, 249, 252, 1);
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    height: 48px;
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    span:nth-child(8) {
      color: #1980ff;
      > span {
        display: inline;
        color: #1980ff;
        &:hover {
          cursor: pointer;
        }
      }
      > span:nth-child(2) {
        margin: 0 4px;
        color: #e6e6e6;
        &:hover {
          cursor: auto;
        }
      }
      /deep/ .el-dropdown{
        width: 30px;
        span{
          color: #1980ff;
        }
      }
      >.more{
          display: inline;
      }
    }
  }
  .pag {
    margin: 22px 0;
    text-align: center;
    /deep/ .btn-prev,
    /deep/ .btn-next {
      padding: 0 8px;
    }
  }
}
</style>